// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__1MQN3","heading":"App_heading__2nYdz"};